module.exports = __webpack_public_path__ + "static/media/ss.d80661fc.svg";